'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".StylelessButton-module_button__kaxON{background:none;border:none;cursor:pointer;padding:0}";
var styles = {"button":"StylelessButton-module_button__kaxON"};
styleInject["default"](css_248z, '7c39be98-b415-4d06-8b78-7c85ad275769');

exports["default"] = styles;
